import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';
import { VisitorUpfrontRegistrationFilterComponent } from './component/visitor-upfront-registration-filter.component';
import { CommonLayoutModule } from '@sdbn/common';


@NgModule({
  declarations: [
    VisitorUpfrontRegistrationFilterComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule
  ],
  exports: [
    VisitorUpfrontRegistrationFilterComponent
  ]
})
export class VisitorUpfrontRegistrationFilterModule { }
